// utils/useConfirmAction.js
import { Box, Card, Typography } from '@material-ui/core'
import { Button, CircularProgress } from '@mui/material'
import { useState } from 'react'

export const useConfirmAction = () => {
  const [isOpen, setIsOpen] = useState(false)
  const [message, setMessage] = useState('Are you sure?')
  const [heading, setHeading] = useState(null)
  const [confirmText, setConfirmText] = useState('Confirm')
  const [onConfirm, setOnConfirm] = useState(() => () => {})
  const [isLoading, setIsLoading] = useState(false)
  const [boxStyle, setBoxStyle] = useState({})

  const confirm = ({
    actionFn,
    heading = null,
    message = 'Are you sure?',
    confirmText = 'Confirm',
    boxStyle = {},
  }) => {
    setHeading(heading)
    setBoxStyle(boxStyle)
    setMessage(message)
    setConfirmText(confirmText)
    setOnConfirm(() => async () => {
      setIsLoading(true)
      try {
        await actionFn()
        setIsOpen(false)
      } catch (error) {
        console.error('Error in confirm action:', error)
      } finally {
        setIsLoading(false)
      }
    })
    setIsOpen(true)
  }

  const ConfirmDialog = () => {
    if (!isOpen) return null

    const handleBackdropClick = (e) => {
      if (e.target.classList.contains('confirm-overlay') && !isLoading) {
        setIsOpen(false)
      }
    }

    return (
      <div className="confirm-overlay" onClick={handleBackdropClick}>
        <Card className="confirm-box" style={boxStyle}>
          {heading && <Typography className="confirm-message-heading">{heading}</Typography>}
          <Box className="confirm-message" component="div">
            {message}
          </Box>
          <Box className="confirm-buttons">
            <Button
              className="btn cancel-btn"
              onClick={() => setIsOpen(false)}
              variant="outlined"
              disabled={isLoading}
            >
              Cancel
            </Button>
            <Button
              className="btn confirm-btn"
              onClick={onConfirm}
              variant="contained"
              disabled={isLoading}
              startIcon={isLoading ? <CircularProgress size={16} color="inherit" /> : null}
            >
              {isLoading ? 'Processing...' : confirmText}
            </Button>
          </Box>
        </Card>
      </div>
    )
  }

  return { confirm, ConfirmDialog }
}
